export default __webpack_public_path__ + "static/media/wakanda2.6dae6fad.jpg";